

import { mapState, mapGetters } from 'vuex'
import { mdiClose } from '@mdi/js'
import catalog from '@/components/tools/catalog'
import SaveSearch from '@/components/catalog/SaveSearch'

export default {
  components: {
    SaveSearch
  },
  data () {
    return {
      mdiClose,
      saveSearchKey: 0
    }
  },
  computed: {
    ...mapState('customer', {
      merchantAcceptedByCm24 (state) {
        return state.merchant?.acceptedByCm24 === true
      },
      merchantInReview (state) {
        return state.merchant?.merchantId && state.merchant?.acceptedByCm24 === null
      }
    }),

    ...mapState('catalog', { total: 'total' }),

    ...mapGetters('catalog', { filters: 'filters' }),

    savedSearchFilterIsReferenced () {
      return this.$route.query.ssid
    },

    selectedSelects () {
      const keys = Object.keys(this.filters)
      let modelSelectIndex

      keys.forEach((key, index) => {
        if (key === 'model_select') {
          modelSelectIndex = index

          return
        }

        if (key === 'make' && modelSelectIndex !== undefined) {
          const modelSelect = keys[modelSelectIndex]
          keys[modelSelectIndex] = key
          keys[index] = modelSelect
        }
      })

      return keys.reduce((selects, key) => {
        const values = this.$route.query[key]

        if (['mileage', 'first_registration', 'target_price'].includes(key) && values) {
          selects.push({ attributeCode: key, value: values })
        } else if (values) {
          const parsedValues = values === 'sold,failed' ? [values] : values.split(',')
          parsedValues.forEach(value => selects.push({ attributeCode: key, value }))
        }

        return selects
      }, [])
    },

    showRemoveAll () {
      return this.selectedSelects?.filter(s => s.attributeCode !== 'auction_status'
      )?.length > 0
    }

  },

  methods: {
    removeAllFilter () {
      const query = Object.assign({}, this.$route.query)
      Object.keys(query).forEach((key) => {
        if (key !== 'auction_status') {
          delete query[key]
        }
      })

      this.$router.replace({ query })
      this.saveSearchKey++
    },

    removeFilter (key, value) {
      const query = Object.assign({}, this.$route.query)

      if (value === 'sold,failed' || ['mileage', 'first_registration', 'target_price'].includes(key)) {
        delete query[key]
      } else {
        const removed = query[key].split(',').filter(item => item !== value).join(',')
        if (removed.length > 0) {
          query[key] = removed
        } else {
          delete query[key]
        }
      }

      this.$router.replace({ query })
    },

    getFilterAttributeLabelShort (attributeCode, value) {
      return catalog.getFilterAttributeLabelShort(this.filters, attributeCode, value, this)
    }
  }
}
